import service from '../../config/axios.config';
import { queryString } from '../../utils/queryString';

export const fetchObjective = ({ objectiveId }) =>
  service.get(`/objectives/${objectiveId}`);

export const fetchObjectives = async ({
  offset = 0,
  filters
}) =>  {
  const queryParams = queryString({ ...filters, offset });
  return await service.get(`/objectives?${queryParams}`);
};

export const fetchGroupObjectives = async ({
  offset = 0,
  filters
}) =>  {
  const queryParams = queryString({ ...filters, offset });
  return await service.get(`/groupObjectives?${queryParams}`);
};

export const createObjective = async ({
  objective
}) =>
  await service.post(`/objectives`, objective);

export const updateObjective = async ({
  objective
}) =>
  await service.put(`/objectives/${objective.id}`, objective);

export const deleteObjective = async objectiveId =>
  await service.delete(`/objectives/${objectiveId}`);

export const updateObjectiveStatus = async ({
  ownerId,
  ownerType,
  objective
}) =>
  await service.put(`/objectives/${objective.id}/status`, {
    ...objective,
    ownerId,
    ownerType
  });

export const updateObjectiveDevelopmentStatus = async ({
  objective
}) =>
  await service.put(`/objectives/${objective.id}/developmentStatus`, objective);

export const updateObjectiveToFailed = async ({
  objectiveData
}) =>
  await service.put(
    `/objectives/${objectiveData.objective.id}/failed`,
    objectiveData
  );

export const fetchObjectiveEventLog = async ({
  createdAt,
  pageNumber,
  objectiveId,
  subjectType
}) => {
  const queryParams = queryString({ subjectType, createdAt, pageNumber });
  return await service.get(`objective/${objectiveId}/eventLogs?${queryParams}`);
};

export const fetchKpiEventLog = async ({
  ownerId,
  ownerType,
  objectiveId,
  kpiId: id,
  createdAt,
  subjectType,
  pageNumber
}) =>  {
  const queryParams = queryString({ subjectType, createdAt, pageNumber });
  return await service.get(`objective/${objectiveId}/kpis/${id}/eventLogs?${queryParams}`);
};